import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './contexts/AuthContext'

// Layout
import Layout from './components/Layout'
import AdminLayout from './components/AdminLayout'

// Pages
import Shop from './pages/Shop'
import ProductDetail from './pages/ProductDetail'
import Cart from './pages/Cart'
import Checkout from './pages/Checkout'
import Orders from './pages/Orders'
import Wallet from './pages/Wallet'
import Profile from './pages/Profile'

// Admin Pages
import AdminDashboard from './pages/admin/Dashboard'
import AdminInventory from './pages/admin/Inventory'
import AdminPOS from './pages/admin/POS'
import AdminOrders from './pages/admin/Orders'
import AIStudio from './pages/admin/AIStudio'

// Protected Route wrapper
function ProtectedRoute({ children, adminOnly = false }: { children: React.ReactNode, adminOnly?: boolean }) {
    const { user, isLoading, isAdmin } = useAuth()

    if (isLoading) {
        return (
            <div className="flex items-center justify-center" style={{ minHeight: '60vh' }}>
                <div className="loader"></div>
            </div>
        )
    }

    if (!user) {
        return <Navigate to="/" replace />
    }

    if (adminOnly && !isAdmin) {
        return <Navigate to="/" replace />
    }

    return <>{children}</>
}

export default function App() {
    return (
        <Routes>
            {/* Public routes with main layout */}
            <Route element={<Layout />}>
                <Route path="/" element={<Shop />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={
                    <ProtectedRoute>
                        <Checkout />
                    </ProtectedRoute>
                } />
                <Route path="/orders" element={
                    <ProtectedRoute>
                        <Orders />
                    </ProtectedRoute>
                } />
                <Route path="/wallet" element={
                    <ProtectedRoute>
                        <Wallet />
                    </ProtectedRoute>
                } />
                <Route path="/profile" element={
                    <ProtectedRoute>
                        <Profile />
                    </ProtectedRoute>
                } />
            </Route>

            {/* Admin routes with admin layout */}
            <Route path="/admin" element={
                <ProtectedRoute adminOnly>
                    <AdminLayout />
                </ProtectedRoute>
            }>
                <Route index element={<AdminDashboard />} />
                <Route path="inventory" element={<AdminInventory />} />
                <Route path="pos" element={<AdminPOS />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="ai-studio" element={<AIStudio />} />
            </Route>

            {/* Catch all */}
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    )
}
